import axios, { AxiosHeaders } from "axios";
import userService from "@/services/auth/user.service";
import authService from "@/services/auth/auth.service";
import vue from "@/main";

const instance = axios.create({
	baseURL: "/",
});
let isPending = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
	refreshSubscribers.push(cb);
};

const onRefreshed = (token) => {
	refreshSubscribers.map((cb) => cb(token));
};

const redirectToLogin = () => {
	try {
		return vue.$router.replace({ name: "login" });
	} catch (error) {
		console.error("redirectToLogin()", error);
	}
};

instance.interceptors.request.use(
	(config) => {
		// app.$Progress.start();
		// Set Authorization header with the internal access token.
		const accessToken = authService.getAccessToken();
		// Keep the SessionId header: backend still uses a Redis session.
		const sessionId = authService.getSessionId();

		config.headers = new AxiosHeaders({
			...config.headers,
			Authorization: accessToken ? `Bearer ${accessToken}` : "",
			["SessionId"]: sessionId || "NOT NULL STRING",
		});
		return config;
	},
	(error) => {
		console.error(error.toJSON());
	},
);

instance.interceptors.response.use(
	(response) => {
		// app.$Progress.finish();
		return Promise.resolve(response);
	},
	(error) => {
		// app.$Progress.finish();
		const {
			config,
			response: { status, data },
		} = error;

		const originalRequest = config;
		// console.log("interceptors onRejected", data);
		if (status === 403) {
			if (
				!`${config.url}`.includes("api/authenticate") &&
				!`${config.url}`.includes("api/re-login") &&
				!`${config.url}`.includes("api/logout")
			) {
				return userService.redirectUnauthorized({
					error: "workflow.noPermission",
				});
			}
			return;
		} else if (status === 401 && !originalRequest._retry) {
			if (
				`${config.url}`.includes("api/authenticate") ||
				`${config.url}`.includes("api/re-login") ||
				`${config.url}`.includes("api/logout")
			) {
				return Promise.reject(error);
			}
			if (data?.error === "authenticate.jwtExpired") {
				if (isPending) {
					return new Promise((resolve) => {
						subscribeTokenRefresh((token) => {
							// replace the expired token and retry
							originalRequest.headers["Authorization"] =
								"Bearer " + token;
							resolve(instance(originalRequest));
						});
					});
				}

				isPending = true;
				originalRequest._retry = true;

				return new Promise((resolve, reject) => {
					authService
						.reLogin()
						.then((response) => {
							if (
								response?.state &&
								response?.data?.accessToken
							) {
								const newToken = response.data.accessToken;
								originalRequest.headers["Authorization"] =
									"Bearer " + newToken;
								onRefreshed(newToken);
								resolve(instance(originalRequest));
							} else {
								// Re-login failed: clear stale tokens so router guard
								// does not redirect back to the app and cause a loop.
								authService.clear();
								redirectToLogin();
								reject(error);
							}
						})
						.catch((err) => {
							authService.clear();
							redirectToLogin();
							reject(err);
						})
						.finally(() => {
							isPending = false;
							refreshSubscribers = [];
						});
				});
			} else {
				if (!isPending) {
					isPending = true;
					return userService.redirectUnauthorized(data);
				}
			}
		}
		return Promise.reject(error);
	},
);

export default instance;
